<template lang="pug" src="./templates/ShippingAddressModal.pug"></template>

<script>
import Cleave from 'vue-cleave-component';
import { validationMixin } from 'vuelidate';
import {
  required, numeric, minLength, maxLength,
} from 'vuelidate/lib/validators';
import PostalCodeInput from '../form/PostalCodeInput.vue';
import { RepositoryFactory } from '../../repositoryFactory';
import notify from '../notify';

import 'cleave.js/src/addons/phone-type-formatter.th';

const ShippingAddressRepository = RepositoryFactory.get('shippingAddress');
const AreaRepository = RepositoryFactory.get('area');

export default {
  components: {
    Cleave,
    PostalCodeInput,
  },
  mixins: [validationMixin],
  props: {
    addressType: {
      type: String,
      default: 'shipping',
    },
    mode: {
      type: String,
      default: 'create',
    },
    name: {
      type: String,
      required: true,
      default: 'shipping-modal',
    },
  },
  data() {
    const data = {
      address: {
        type: this.addressType,
        first_name: '',
        last_name: '',
        tel: '',
        address: '',
        postal_code: '',
        province_id: '',
        amphure_id: '',
        district_txt: '',
      },
      options: {
        provinces: [],
        amphures: [],
        districts: [],
      },
      inputOptions: {
        tel: {
          phone: true,
          phoneRegionCode: 'TH',
          delimiter: '',
        },
      },
    };
    return data;
  },
  mounted() {
    this.getProvinces();

    this.$watch('address.province_id', (val, oldVal) => {
      if (val !== oldVal) {
        if (oldVal !== '') {
          this.address = { ...this.address, ...{ amphure_id: '', district: '' } };
          this.options = { ...this.options, ...{ amphures: [], districts: [] } };
        }
        this.getAmphures({ province_id: val });
      }
    });

    this.$watch('address.amphure_id', (val, oldVal) => {
      if (val !== oldVal) {
        if (oldVal !== '') {
          this.address = { ...this.address, ...{ district: '' } };
          this.options = { ...this.options, ...{ districts: [] } };
        }
      }
    });
  },
  methods: {
    async getProvinces() {
      const { data } = await AreaRepository.getProvinces();
      this.options.provinces = data;
    },
    async getAmphures(query) {
      const { data } = await AreaRepository.getAmphures(query);
      this.options.amphures = data;
    },
    async getDistricts(query) {
      const { data } = await AreaRepository.getDistricts(query);
      this.options.districts = data;
    },
    onPostalCodeUpdate(val) {
      this.$v.address.postal_code.$model = val;
    },
    onPostalCodeSelected(item) {
      this.$v.address.postal_code.$model = item.zip_code;
      this.$v.address.province.$model = item.amphure.province;
      delete item.amphure.province;
      this.$v.address.amphure.$model = item.amphure;
      delete item.amphure;
      this.$v.address.district.$model = item;
    },
    async getAddress(id) {
      try {
        const { data } = await ShippingAddressRepository.show(id).then((resp) => resp.data);
        this.address = { ...this.address, ...data };
      } catch (e) {
        this.$bvModal.hide(`edit-shipping-modal-${this.address.id}`);
        notify.errors(this, e);
      }
    },
    onOpened() {
      if (this.mode === 'edit') {
        this.getAddress(this.$attrs.addressId);
      }
      if (this.mode === 'create') {
        // eslint-disable-next-line camelcase
        const { first_name, last_name, tel } = this.$store.getters['auth/user'];
        this.address = {
          ...this.address,
          ...{
            first_name, last_name, tel,
          },
        };
      }
    },
    async onSave() {
      this.$wait.start('creating shipping address');
      try {
        const { data } = await ShippingAddressRepository.store(this.address);
        this.$emit('created', data);
        notify.success(this, { title: Lang.get('alerts.general.operation_completed'), text: false });
        this.$bvModal.hide('create-shipping-modal');
      } catch (e) {
        notify.errors(this, e);
      }
      this.$wait.end('creating shipping address');
    },
    async onUpdate() {
      this.$wait.start('updating shipping address');
      try {
        const { data } = await ShippingAddressRepository.update(this.address);
        this.$emit('updated', data);
        notify.success(this, { title: Lang.get('alerts.general.operation_completed'), text: false });
        this.$bvModal.hide(`edit-shipping-modal-${this.address.id}`);
      } catch (e) {
        notify.errors(this, e);
      }
      this.$wait.end('updating shipping address');
    },
    onHidden() {
      this.$v.$reset();
      this.address = {
        type: this.addressType,
        first_name: '',
        last_name: '',
        tel: '',
        address: '',
        postal_code: '',
        province_id: '',
        amphure_id: '',
        district: '',
      };
    },
  },
  validations: {
    address: {
      first_name: {
        required,
      },
      last_name: {
        required,
      },
      tel: {
        required,
      },
      address: {
        required,
      },
      province_id: {
        required,
      },
      amphure_id: {
        required,
      },
      district_txt: {
        required,
      },
      postal_code: {
        required,
        numeric,
        minLength: minLength(5),
        maxLength: maxLength(5),
      },
    },
  },
};
</script>
